<template>
  <Export
    :formats="[
            { value: 'csv', label: $t('as CSV file') },
            { value: 'xls', label: $t('as XLS file') },
            { value: 'pdf', label: $t('as PDF file') },
        ]"
    :disabled="disabled"
    @export="$emit('export', arguments[0])"
  />
</template>

<script>
  import Export from '@/_legacy/views/Analytics/components/Export.vue';

  export default {
    components: {
      Export,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
